import { isDemoMode } from '../firebase';
import type { Backend } from './types';
import { DemoBackend } from './demoBackend';
import { FirebaseBackend } from './firebaseBackend';

export type { Backend } from './types';

let backend: Backend | null = null;

export function getBackend(): Backend {
  if (!backend) {
    backend = isDemoMode() ? new DemoBackend() : new FirebaseBackend();
  }
  return backend;
}
